import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/common/header.css";

const LoginButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const navigateToLogin = () => {
    navigate("/login", { state: { from: location } });
  };

  return (
    <button className="login-button" onClick={navigateToLogin}>
      LOGIN
    </button>
  );
};

export default LoginButton;
